import script from "./SmsCodeVerification.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmsCodeVerification.vue?vue&type=script&lang=ts&setup=true"

import "./SmsCodeVerification.vue?vue&type=style&index=0&id=68ccbf2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68ccbf2e"]])

export default __exports__